export function isTerminatedStatutLabel(label) {
  if (!label) return false;
  return label.trim().localeCompare("Terminée", undefined, { sensitivity: "accent" }) === 0;
}

export function chipColorForStatut(label) {
  if (!label) return "default";
  const l = label.toLowerCase();
  if (l.includes("demande")) return "default";
  if (l.includes("affect")) return "info";
  if (l.includes("cours")) return "warning";
  if (l.includes("attente")) return "secondary";
  if (l.includes("termin")) return "success";
  if (l.includes("réouvr") || l.includes("reouvr")) return "error";
  return "default";
}
